import { OndigoNS } from '../../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.BackToSelection = function () {
        this.$backButton = $('.backToSelectionButton');
        this.angeboteUrl = "immobilienangebote";
        this.backUrl="";
        this.init();
    };

    OndigoNS.BackToSelection.prototype = {
        init: function () {
            var _scope = this;
            this.backUrl=document.referrer;
            _scope.$backButton.on('click',function(){
                if(_scope.backUrl.indexOf(_scope.angeboteUrl) >= 0){
                    if( window.location.href.indexOf("#contact")===-1){
                        _scope.$backButton.attr("href",'javascript:history.back()');
                    }else{
                        _scope.$backButton.attr("href",'javascript:history.go(-2)');
                    }
                }
            })
        }
    };
    // plugin definition
    $.fn.backToSelection = function () {
        return new OndigoNS.BackToSelection();
    };
    $.fn.backToSelection.Constructor = OndigoNS.BackToSelection;

}(window.jQuery));

$(document).ready(function () {
    'use strict';
    var $backButton = $('.backToSelectionButton');
    if ($backButton.length) {
        $.fn.backToSelection();
    }

});